import { BingoGame } from "bingo/types/bingo-game.model";

const BLANK_LOGO = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

export function ScreencastLogo({ bingoGame }: { bingoGame: BingoGame }) {
  return (
    <div className="absolute">
      <img
        src={bingoGame.bingoTemplateSnapshot.images.screenLogo || BLANK_LOGO}
        alt="Default Logo"
        style={{
          zIndex: 0,
          marginTop:
            bingoGame.bingoTemplateSnapshot?.publicScreenSettings
              .screenTopMargin,
          marginLeft:
            bingoGame.bingoTemplateSnapshot?.publicScreenSettings
              .screenLeftMargin,
          width: "120px",
          height: "120px",
        }}
      />
    </div>
  );
}
